<template>
  <div class="container-page">
    <p class="title-inner">Таможенные пошлины</p>

    <div class="mb-16 flex-container flex-container__justify-content-between">
      <div class="flex-container button-container">
        <ButtonComponent @click="editCard(0)" mod="gradient-bg">Создать</ButtonComponent>
        <ButtonComponent @click="onOpenImport()" mod="gradient-bg" :disabled="isImport">
          {{ !isImport ? 'Загрузить из Excel' : 'Загрузка...' }}
        </ButtonComponent>
      </div>
      <div class="analytics-source-text">Источник: ITC Market Access Map</div>
    </div>
    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>

    <div>
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Год</th>
              <th>Страна</th>
              <th>Товар</th>
              <th>Код ТН ВЭД</th>
              <th>Торговый режим</th>
              <th>Применяемый тариф</th>
              <th>Адвалорный эквивалент</th>
              <th>Документы</th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput
                  type="year"
                  v-model="filter.year"
                  placeholder="Год"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  type="select2"
                  :select2Options="countries"
                  :select2Settings="select2SettingsMulti"
                  v-model="filter.reporters"
                  multiple
                  placeholder="(Все)"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter" colspan="2">
                <FilterInput
                  v-model="filter.product"
                  placeholder="Код или название ТН ВЭД"
                  @valueChangedDebounced="changeFilter"
                />

                <FilterInput
                  id="chkSkipEmptyTnved"
                  v-model="filter.skipEmptyTnved"
                  type="checkbox"
                  label="Не показывать записи без товаров"
                  class="ml-4"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  v-model="filter.tariffRegime"
                  placeholder="Торговый режим"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  v-model="filter.tariffReported"
                  placeholder="Применяемый тариф"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  v-model="filter.tariffAve"
                  placeholder="Адвалорный эквивалент"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  id="chkSkipEmptyDocs"
                  v-model="filter.skipEmptyDocs"
                  type="checkbox"
                  label="Наличие"
                  class="ml-4"
                  @valueChangedDebounced="changeFilter"
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.year }}</td>
              <td>{{ item.countryImporter?.nameFull || item.countryImporter?.name }}</td>
              <td>
                <div class="font-italic">{{ item.tnvedGroup?.name }}</div>
                <div>{{ item.tnved?.name }}</div>
              </td>
              <td>
                {{ item.tnvedGroup?.code }}
              </td>
              <td>{{ item.tariffRegime }}</td>
              <td>{{ item.tariffReported }}</td>
              <td>{{ item.tariffAve }}</td>
              <td>
                <div v-html="getItemNote(item)"></div>
              </td>
              <td>
                <IconComponent @click="editCard(item.id)" name="mode" />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="7">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="7">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
  </div>

  <section>
    <ModalComponent v-model="isOpenModal" title="Импорт файла" @close="onCloseModal">
      <ImportModalRedesigned @doimport="doImport" @close="onCloseModal" />
    </ModalComponent>
  </section>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ImportModalRedesigned from '@/common/components/redesigned/ImportModalRedesigned.vue';
  import Constants from '@/common/constants';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import analyticsApi from '@/modules/importanalytics/api';

  import FilterInput from '../../../common/components/FilterInput.vue';
  import IconComponent from '../../../common/ui/IconComponent.vue';
  import Api from '../api/macmaporgcustomsduties';

  export default {
    name: 'MacmaporgCustomsDuties',
    components: { IconComponent, FilterInput, ButtonComponent, DefaultFilter, ModalComponent, ImportModalRedesigned },
    data() {
      return {
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          year: 2022,
          reporters: [],
          product: null,
          tariffRegime: null,
          tariffReported: null,
          tariffAve: null,
          skipEmptyTnved: true,
          skipEmptyDocs: false,
        },
        countries: [],
        select2SettingsMulti: Constants.select2SettingsMultiple,
        isLoading: false,
        isOpenModal: false,
        isImport: false,
      };
    },
    created() {
      loadFilter(this.$options.name).then((response) => {
        let filter = response;
        if (filter) {
          this.filter = filter;
        }
        this.loadDictionaries();
        this.loadPage(false);
      });
    },
    methods: {
      loadPage(append) {
        this.isLoading = !append;
        const request = Object.assign(this.filter, this.request);
        Api.search(request)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      loadDictionaries() {
        Utils.searchNsi('countrylistwithdata', {})
          .then((response) => {
            this.countries = response.data
              .filter((x) => x.codeForDuties != null)
              .map((x) => {
                return { text: x.name, id: x.codeForDuties };
              });
          })
          .catch((error) => {
            console.error(error?.response?.data);
          });
      },
      getItemNote(item) {
        if (!item.tariffNote) return '';
        const docs = item.tariffNote.documents;
        if (!docs?.length) return '';
        const docEntry = docs[0];
        let result = [];
        if (docEntry.certificates?.length) {
          docEntry.certificates.forEach((d) => {
            result.push(`<div><a href="${d.url}" target="_blank">${d.title}</a></div>`);
          });
        }
        if (docEntry.rulesOfOrigins?.length) {
          docEntry.rulesOfOrigins.forEach((d) => {
            result.push(`<div><a href="${d.url}" target="_blank">${d.title}</a></div>`);
          });
        }
        return result.join('\n');
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      editCard(id) {
        this.$router.push({ name: 'MacmaporgCustomsDutyCard', params: { id: id, action: 'edit' } });
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      onOpenImport() {
        this.isOpenModal = true;
      },
      onCloseModal() {
        this.isOpenModal = false;
      },
      doImport(file) {
        this.onCloseModal();
        this.isImport = true;
        analyticsApi
          .downloadFile('MacmaporgCustomsDuties', file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
          })
          .catch((error) => {
            Constants.alert.fire(
              'Импорт',
              error?.response?.data ? error?.response?.data : 'Ошибка при импорте данных.',
              'error',
            );
          })
          .finally(() => {
            this.isImport = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .filter {
    .form-label {
      font-size: 14px !important;
    }
  }

  .flex-container {
    display: flex;

    &__justify-content-between {
      justify-content: space-between;
    }
  }

  .button-container {
    gap: 16px;
  }
</style>
